import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sale",
  "use": "icon-sale-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sale\"><defs><style type=\"text/css\"></style></defs><path d=\"M474.255 109.527c-246.784 0-446.935 200.151-446.935 446.976 0 246.907 200.151 447.017 446.935 447.017 135.291 0 256.39-60.17 338.35-155.075l-338.35-291.962V109.527z\" p-id=\"3490\" /><path d=\"M996.68 467.517c0-246.967-200.05-447.037-446.874-447.037v447.037H996.68z m-446.874 62.935l338.207 291.902c67.686-78.336 108.667-180.367 108.667-291.902H549.806z\" p-id=\"3491\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sale.svg
// module id = LguS
// module chunks = 19